import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { promotionEndDate } from 'reactApp/appHelpers/featuresHelpers';

const segment = !IS_PAID_USER && !IS_BIZ_USER && !IS_CORP_USER;

export const septemberPromo2025: boolean = segment && promotionEndDate && getFeature('september-promo-2025');
